const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const UrlHelpers = require('components/shared/url_helpers');

class ExpeditedShippingToggle extends React.Component {
  static expeditedShippingDetailsPath() {
    return UrlHelpers.cmsPagePath('two-day-shipping');
  }

  constructor(props) {
    super(props);
    this.enableExpeditedShipping = this.enableExpeditedShipping.bind(this);
    this.disableExpeditedShipping = this.disableExpeditedShipping.bind(this);
  }

  enableExpeditedShipping() {
    this.props.onChange(true);
  }

  disableExpeditedShipping() {
    this.props.onChange(false);
  }

  renderExpeditedShippingSummary() {
    if (this.props.canToggle) {
      return false;
    }

    return (
      <div className="g-col-9 g-col-mobile-12">
        <div
          className="free-two-day-shipping mtb-half"
          dangerouslySetInnerHTML={{
            __html: I18n.t('shippingRates.expeditedShipping.qualifyExpeditedShipping', {
              open_tag: `<a href="${ExpeditedShippingToggle.expeditedShippingDetailsPath()}" target="_blank">`,
              close_tag: '</a>',
            }),
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <div id="expedited_shipping_toggle">
        <label
          className={
            classNames('mb-half', { 'opacity-50': !this.props.canToggle })
          }
        >
          {I18n.t('shippingRates.expeditedShipping.title')}
        </label>
        <div className="g-container">
          <div
            className={
              classNames('g-col-3', 'g-col-mobile-12', 'mobile-mb-half', {
                'opacity-50': !this.props.canToggle,
              })
            }
          >
            <div className="btn-group btn-group--radios">
              <input
                type="radio"
                name={`${this.props.fieldsPrefix}[offers_expedited_shipping]`}
                id={`${this.props.fieldsPrefix}_offers_expedited_shipping_true`}
                value="true"
                disabled={!this.props.canToggle}
                onChange={this.enableExpeditedShipping}
                defaultChecked={this.props.isEnabled}
                data-slide-down-target=".expedited-shipping-requirements"
              />
              <label
                className="btn btn-group--radios__btn"
                htmlFor={`${this.props.fieldsPrefix}_offers_expedited_shipping_true`}
              >
                {I18n.t('shippingRates.expeditedShipping.yes')}
              </label>
              <input
                type="radio"
                name={`${this.props.fieldsPrefix}[offers_expedited_shipping]`}
                id={`${this.props.fieldsPrefix}_offers_expedited_shipping_false`}
                value="false"
                disabled={!this.props.canToggle}
                onChange={this.disableExpeditedShipping}
                defaultChecked={!this.props.isEnabled}
                data-slide-up-target=".expedited-shipping-requirements"
              />
              <label
                className="btn btn-group--radios__btn"
                htmlFor={`${this.props.fieldsPrefix}_offers_expedited_shipping_false`}
              >
                {I18n.t('shippingRates.expeditedShipping.no')}
              </label>
            </div>
          </div>
          {this.renderExpeditedShippingSummary()}
        </div>
        <p
          className={
            classNames('fine-print', 'mb-0', {
              'global-slidedown--open': this.props.isEnabled,
              'global-slidedown--closed': !this.props.isEnabled,
            })
          }
          dangerouslySetInnerHTML={{
            __html: I18n.t('shippingRates.expeditedShipping.finePrint', {
              link_open:
                `<a target="_blank" href="${ExpeditedShippingToggle.expeditedShippingDetailsPath()}">`,
              link_close: '</a>',
            }),
          }}
        />
      </div>
    );
  }
}

ExpeditedShippingToggle.propTypes = {
  fieldsPrefix: PropTypes.string.isRequired,
  showExpeditedFields: PropTypes.bool,
  showIncrementalFields: PropTypes.bool,
  isEnabled: PropTypes.bool,
  canToggle: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

module.exports = ExpeditedShippingToggle;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_rates/expedited_shipping_toggle.jsx